export const BuilderWizardRoutes = [
  {
    path: 'easy-builder-wizard',
    alias: 'easyBuilderWizard',
    query: ['type'],
    lazy: () => import('common/cms/pages/easy-builder-wizard.page'),
  },
  {
    path: 'quick-automations-wizard/:flowId?',
    alias: 'quickAutomationsWizard',
    query: ['step', 'preset'],
    lazy: () => import('common/cms/pages/quick-automations-wizard.page'),
  },
] as const
